module.exports = __webpack_public_path__ + "img/UTDEER-4.46bac4d6.jpg";